export const faqData = {
	title: 'Frequently asked questions',
};
